import React from 'react';

import { companyData } from '../static/data';
import Intro from '../components/Intro';
import CTA from '../components/CTA';
import Reasoning from '../components/Reasoning';
import SocialBlock from '../components/SocialBlock';
import ScrollToTop from '../components/ScrollToTop';
import SEO from '../components/SEO';

function Company() {
  let { intro, reasoning } = companyData;
  return (
    <>
      <SEO
        title="WE3 Academy | About Us | Company"
        description="Our aim is to bridge the gap between education and employability with our in-person training courses designed to provide real world experiences and empower our students to be able to build their own products."
        keywords="WE3 Academy, WE3, Coding Bootcamp, education, education center, educational institute, career courses, digital courses, course, courses, part time courses, part time course, full time courses, training courses, training, in-person training, real world experiences, real work environment, employability, training institute, training bootcamp, training center,  in person training course, in person training courses"
        link="/company"
      />
      <section id="company">
        <ScrollToTop />
        <Intro sectionId="companyIntro" intro={intro} />
        <Reasoning sectionId="reasoning" reasoning={reasoning} />
        <SocialBlock styleType="style1" />
        <CTA styleType="style5" />
      </section>
    </>
  );
}

export default Company;
